import { Box } from "@chakra-ui/react";
import { customEvent, OverlayModal } from "goi_common";

import { ParlorDetailProps } from "@/types/parlor";
import { useOverlay } from "@toss/use-overlay";
import { colors, FUNERAL_SIDO, FUNERAL_SIGUNGU, HStack, useResponsive, VStack } from "goi_common";
import { useCallback, useEffect, useMemo, useState } from "react";
import ImageSlideSection from "./components/ImageSlideSection";
import MainInfoSection from "./components/MainInfoSection";
import ParlorIntentShortcuts from "./components/ParlorIntentShortcuts";

import { useRouter } from "next/router";
import FlowerModalContent from "./components/Modal/FlowerModalContent";
import ParlorFixedButtons from "./components/ParlorFixedButtons";
import TabInfoSection from "./components/TabInfoSection";
import { NAVIGATOR_HEIGHT } from "@/constants/components";
import ParlorRevisitExperimentGate from "./components/ParlorRevisitExperimentGate";
import CareFacilityLeadGate from "@/components/CareFacilityLead/CareFacilityLeadGate";
import ParlorCompareExperimentGate from "./components/ParlorCompareExperimentGate";
import { parlorToCompareVisit } from "./utils/parlorVisitPayload";
import { useParlorDetailIsRevisit } from "@/hooks/useParlorDetailIsRevisit";

function ParlorDetailTableVersionContainer({
  parlor,
  closestParlorsByService,
  nearbyFacilities,
  discountDescription,
  isExcluded,
  pageDescription,
}: {
  parlor: ParlorDetailProps;
  refetch: any;
  closestParlorsByService: any;
  nearbyFacilities?: any;
  discountDescription?: string;
  isExcluded: boolean;
  pageDescription: string;
}) {
  const [selectedSangjo, setSelectedSangjo] = useState("가족장");
  const overlay = useOverlay();
  const { isBiggerThanLg } = useResponsive();

  const router = useRouter();

  const isRevisit = useParlorDetailIsRevisit(parlor.id);
  const regionLabel = [
    FUNERAL_SIDO.get(Number(parlor.sido)),
    FUNERAL_SIGUNGU.get(Number(parlor.sido))?.get(Number(parlor.sigungu)),
  ]
    .filter(Boolean)
    .join(" ");

  /** 재방문 모달 임시 제거
   * useParlorDetailRevisitModal();
   */

  // useEffect(() => {
  //   setVisitedFeature("parlor-detail");

  //   overlay.open(({ isOpen, close: onClose }) => {
  //     return (
  //       <OverlayModal
  //         onClose={onClose}
  //         isOpen={isOpen}
  //         closeOnOverlayClick
  //         modalContentStyle={{
  //           minWidth: "280px",
  //           overflow: "scroll",
  //         }}
  //         // overlayModalContent={<RevisitParlorModalContent onClose={onClose} />}
  //         overlayModalContent={<PremiumSalesRevisitParlorModal onClose={onClose} />}
  //       />
  //     );
  //   });
  // }, []);

  const openFlowerModal = useCallback(
    ({ parlorId }: { parlorId: number }) => {
      overlay.open(({ isOpen, close: onClose }) => {
        return (
          <OverlayModal
            onClose={onClose}
            isOpen={isOpen}
            closeOnOverlayClick={true}
            modalContentStyle={{
              minWidth: "380px",
              minHeight: isBiggerThanLg ? "" : "90vh",
            }}
            overlayModalContent={
              <FlowerModalContent
                companyName={parlor.companyname}
                parlorId={parlorId}
                onClose={onClose}
              />
            }
            header={{
              content: <FlowerModalContent.header onClose={onClose} />,
            }}
          />
        );
      });
    },
    [overlay, parlor, isBiggerThanLg],
  );

  useEffect(() => {
    if (router.query.showFlowerModal === "true") {
      openFlowerModal({
        parlorId: Number(parlor.id),
      });
    }
  }, [router.query, openFlowerModal]);

  const closestParlors = useMemo(() => {
    if (parlor) {
      return closestParlorsByService[selectedSangjo];
    }
  }, [selectedSangjo, parlor]);

  const visitPayload = parlorToCompareVisit(parlor, regionLabel || "");

  // const openQuestionSubmitModal = () => {
  //   overlay.open(({ isOpen: isOpenModal, close: onCloseModal }) => {
  //     return (
  //       <Box height="100%" width="100%">
  //         <Modal
  //           isOpen={isOpenModal}
  //           onClose={onCloseModal}
  //           closeOnOverlayClick
  //           scrollBehavior="inside"
  //           isCentered
  //           useInert={false}
  //         >
  //           <ModalOverlay width="100%" height="100%" />
  //           <ModalContent
  //             minWidth="300px"
  //             backgroundColor={colors.white}
  //             backgroundSize="cover"
  //             padding="0"
  //           >
  //             <ModalBody padding="0">
  //               <VStack>
  //                 <Box padding="24px" className="subtitle_18_b gray900">
  //                   빈소 할인 30만원, 미리 계약하기
  //                 </Box>
  //                 <Box
  //                   background={colors.warmGray100}
  //                   className="body_14_m gray700"
  //                   padding="24px 8px"
  //                   textAlign="center"
  //                   marginBottom="36px"
  //                 >
  //                   사전 계약 후,
  //                   <br /> 고이 장례 패키지를 이용하여
  //                   <br />
  //                   장례를 진행하는 경우.
  //                   <br />
  //                   빈소 할인 지원금 30만원을
  //                   <br /> <b>할인 혹은 페이백 형태로 지급</b>합니다.
  //                   <br />
  //                   <br />
  //                   <span className="caption_12_m orange650">
  //                     단, 고이장례연구소 상조 서비스중 회원가 기준 200만원 이상 상품(가족장 이상)을
  //                     이용하는 경우에 한하여 적용됩니다.
  //                   </span>
  //                 </Box>
  //                 <Box textAlign="center" className="caption_12_b black">
  //                   <a href="/service/">고이장례연구소 상조 서비스 확인하러가기 {">"}</a>
  //                 </Box>
  //                 <Box textAlign="center" className="caption_12_m black">
  //                   문의전화: 1666-9784
  //                 </Box>
  //                 <Box padding="24px 12px 12px">
  //                   <LargeButton
  //                     className="button_16_sb"
  //                     buttonType={LARGEL_BUTTON_TYPE.ORANGE}
  //                     onClick={() => {
  //                       router.push(
  //                         `https://prime.goifuneral.co.kr/registration/verification/?productKey=PARLOR30V3&account=1`,
  //                       );
  //                       customEvent({
  //                         newGtm: {
  //                           path: "home",
  //                           trigger_and_target: "parlor_detail-go_PARLOR30V2_contract",
  //                         },
  //                       });
  //                     }}
  //                   >
  //                     지금 가입하기
  //                     <br />
  //                     (빈소할인 30만원 보장)
  //                   </LargeButton>
  //                 </Box>
  //               </VStack>
  //             </ModalBody>
  //           </ModalContent>
  //         </Modal>
  //       </Box>
  //     );
  //   });
  // };

  return (
    <>
      {isRevisit && (
        <ParlorRevisitExperimentGate
          key={`same-${parlor.id}`}
          parlorId={parlor.id}
          companyName={parlor.companyname}
          region={regionLabel || undefined}
        />
      )}
      {!isRevisit && (
        <CareFacilityLeadGate
          path="parlor_detail"
          facilityName={parlor.companyname}
          sido={parlor.sido}
          sigungu={parlor.sigungu}
        />
      )}
      <ParlorCompareExperimentGate
        key={`compare-${parlor.id}`}
        parlorId={parlor.id}
        companyName={parlor.companyname}
        region={regionLabel || ""}
        imageUrl={visitPayload.imageUrl}
        minPriceManwon={visitPayload.minPriceManwon}
      />
      <VStack width="100%" alignItems="center">
        <VStack width="100%" maxWidth="480px">
          <HStack
            maxWidth="480px"
            onClick={() => {
              router.push("/funeral-prepare/company-introduction");
              customEvent({
                newGtm: {
                  path: "parlor_detail",
                  trigger_and_target: "uv_company_introduction",
                },
              });
            }}
            width="100%"
            position="fixed"
            zIndex={2}
            top={`${NAVIGATOR_HEIGHT - 6}px`}
            background={colors.gray900}
            padding="10px 12px"
            alignItems="center"
          >
            <Box className="body_14_m white" textAlign="start" width="100%">
              장례식장 정보·예상 비용 - 고이장례연구소
            </Box>
          </HStack>
          <>
            <Box position="relative" paddingTop={"0px"}>
              {/* {discountDescription && (
                  <Box
                    position="absolute"
                    top="20px"
                    left="12px"
                    zIndex="1"
                    background="rgba(0, 0, 0, 0.5)"
                    backdropFilter="blur(2px)"
                    borderRadius="18px"
                    padding="2px 10px 2px 2px"
                  >
                    <HStack gap="4px" alignItems="center" justifyContent="center">
                      <Box
                        margin="auto"
                        background={colors.gray900}
                        padding="4px"
                        borderRadius="50%"
                      >
                        <ColorIcon
                          name="icon-medal-check-mono"
                          color={colors.reviewYellow}
                          width={16}
                          height={16}
                        />
                      </Box>
                      <HStack gap="6px" alignItems="center" justifyContent="center">
                        <GoiLogo color={colors.white} size={16} />
                        <span className="button_12_sb white">빈소 할인 제휴 장례식장</span>
                      </HStack>
                    </HStack>
                  </Box>
                )} */}

              <ImageSlideSection
                images={parlor.images}
                name={parlor.companyname}
                height="180px"
                region={parlor.address?.split(" ").slice(0, 2).join(" ")}
              />
            </Box>
            {/* <Box marginTop="-112px" zIndex="1">
                <HStack
                  gap={6}
                  height="112px"
                  padding="18px 16px"
                  background="#000000cc"
                  justifyContent="space-between"
                  alignItems="center"
                  css={{ cursor: "pointer" }}
                  onClick={() => {
                    openQuestionSubmitModal();
                    customEvent({
                      newGtm: {
                        path: "parlor_detail",
                        trigger_and_target: "image_banner-contract_parlor",
                      },
                    });
                  }}
                >
                  <VStack>
                    <div className={`body_14_m green150`}>
                      <Box className={`subtitle_16_b white`}>
                        빈소 할인 30만원, 미리 계약하기
                        <br />
                      </Box>
                      <Box className={`caption_12_b green50`}>
                        사전 계약 후(계약금 3만원) 고이 장례 패키지 이용, 장례 진행시
                        <br />
                        30만원 빈소 할인 지원금을 드립니다.
                        <br />
                        (패키지 200만원 이상 적용, 장례종료일 기준 30일 이내 지급)
                      </Box>
                    </div>
                  </VStack>
                  <VStack
                    background="white"
                    width="24px"
                    height="24px"
                    borderRadius="32px"
                    alignItems="center"
                    justifyContent="center"
                    boxShadow="0px 0px 12px rgba(0, 0, 0, 0.12)"
                  >
                    <ColorIcon name="arrow_right_small" size={16} color={colors.black} />
                  </VStack>
                </HStack>
              </Box> */}
            <MainInfoSection
              sido={parlor.sido}
              sigungu={parlor.sigungu}
              companyName={parlor.companyname}
              address={parlor.address}
              isDiscount={Boolean(discountDescription)}
              id={parlor.id}
              isExcluded={isExcluded}
            />
            <ParlorIntentShortcuts parlor={parlor} />

            <TabInfoSection
              isExcluded={isExcluded}
              closestParlors={closestParlors}
              nearbyFacilities={nearbyFacilities}
              discountDescription={discountDescription}
              parlor={parlor}
              selectedSangjo={selectedSangjo}
              setSelectedSangjo={setSelectedSangjo}
            />
          </>
        </VStack>
      </VStack>
      {/* <CallFixedButton maxWidth="480px" bottom={{ md: "72px" }} /> */}
      {/* <ParlorPromotionModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        name={parlor.companyname}
      /> */}
      {/* <StepGuideFooter /> */}
      <ParlorFixedButtons
        parlor={parlor}
        selectedSangjo={selectedSangjo}
        closestParlors={closestParlors}
      />
      {/* <ParlorChatbot companyname={parlor.companyname} /> */}
    </>
  );
}
export default ParlorDetailTableVersionContainer;
